export enum Environments {
	Development = 'dev',
	QA = 'qa',
	Staging = 'staging',
	Production = 'prod',
}
